import React, {useEffect} from 'react';
import Service from './Service';
import {motion, useAnimation} from 'framer-motion';
import {useInView} from 'react-intersection-observer';

export default function Services(props) {
  const {animation, handleModal, handleModalInfo} = props;
  // HIDE / SHOW WINDOW
  const controls = useAnimation();
  const {ref, inView} = useInView({threshold: 0.3});

  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
    if (!inView) {
      controls.start('hidden');
    }
  }, [controls, inView]);

  return (
    <section ref={ref} className='services section' id='services'>
      <motion.div
        initial='hidden'
        animate={controls}
        variants={animation}
        className='wrapper'
      >
        <span className='section__subtitle'>My Services</span>
        <h2 className='section__title'>What I Offer</h2>
        <div className='services__container-flex'>
          <div className='services__container container grid'>
            <Service
              props={{
                handleModal: handleModal,
                handleModalInfo: handleModalInfo,
                title: `FrontEnd Developer`,
                modalTitle: 'FrontEnd Developer',
                modalSubTitle:
                  'Developing concepts or ideas through design and functionality .',
                content: [
                  'Using HTML, JavaScript and CSS to bring concepts to life.',
                  'Creating tools that improve site interaction regardless of the browser.',
                  'Follow SEO best practices.',
                  'Managing software workflow.',
                  'Fixing bugs and testing for usability.',
                ],
              }}
            />
            <Service
              props={{
                handleModal: handleModal,
                handleModalInfo: handleModalInfo,
                title: (
                  <>
                    Ui/Ux
                    <br />
                    Designer
                  </>
                ),
                modalTitle: 'Ui/Ux Designer',
                modalSubTitle:
                  'Creation of responsive user experiences in conjunction with the client needs.',
                content: [
                  'Gathering and evaluating user requirements.',
                  'Designing graphic user interface elements, like menus, tabs and widgets.',
                  'Build page navigation buttons and search fields.',
                  'Conduct layout adjustments based on user feedback.',
                ],
              }}
            />
          </div>
          <div className='services__card-flex container grid'>
            <Service
              props={{
                handleModal: handleModal,
                handleModalInfo: handleModalInfo,
                title: (
                  <>
                    Visual <br /> Designer
                  </>
                ),
                modalTitle: 'Visual Designer',
                modalSubTitle: 'Websites/Applications design and layout  . ',
                content: [
                  'Design logos, icons and infographics.',
                  'Establish the look and feel for various interfaces, including websites, mobile devices, apps, etc...',
                  'Work within brand guidelines to create layouts that reinforce a brand’s style or voice through its visual touchpoints.',
                  'Resize assets for different devices — tablet, mobile and web.',
                  'Juggle multiple projects while effectively managing timelines and expectations.',
                ],
              }}
            />
          </div>
        </div>
      </motion.div>
    </section>
  );
}
